<div *ngIf="inputStatus !== undefined" [ngClass]="{ 'in-table': inTable }">
    <mat-slide-toggle *ngIf="editable" [formControl]="status" (change)="onChange()"></mat-slide-toggle>
    <mat-slide-toggle *ngIf="!editable" [formControl]="status" (click)="$event.preventDefault()"> </mat-slide-toggle>
</div>
